import { createLogger } from "@/domain/logging";

export const qrDecoderLog = createLogger("DECODER");
